__turbopack_context__.v({
  "background-step-black-v2": "section-module-scss-module__PlCZ3a__background-step-black-v2",
  "background-step-coal-mine-canary": "section-module-scss-module__PlCZ3a__background-step-coal-mine-canary",
  "background-step-cyanora": "section-module-scss-module__PlCZ3a__background-step-cyanora",
  "background-step-future-fuscia": "section-module-scss-module__PlCZ3a__background-step-future-fuscia",
  "background-step-linear-gradient-cyanora-to-future-fuscia": "section-module-scss-module__PlCZ3a__background-step-linear-gradient-cyanora-to-future-fuscia",
  "background-step-midnight": "section-module-scss-module__PlCZ3a__background-step-midnight",
  "background-step-off-white": "section-module-scss-module__PlCZ3a__background-step-off-white",
  "background-step-right-before-midnight": "section-module-scss-module__PlCZ3a__background-step-right-before-midnight",
  "background-step-vertical-gradient-cyanora-to-future-fuscia": "section-module-scss-module__PlCZ3a__background-step-vertical-gradient-cyanora-to-future-fuscia",
  "background-step-white": "section-module-scss-module__PlCZ3a__background-step-white",
  "background-transparent": "section-module-scss-module__PlCZ3a__background-transparent",
  "box": "section-module-scss-module__PlCZ3a__box",
  "grid": "section-module-scss-module__PlCZ3a__grid",
  "loading": "section-module-scss-module__PlCZ3a__loading",
  "pad-horizontal": "section-module-scss-module__PlCZ3a__pad-horizontal",
  "scroll-anchor": "section-module-scss-module__PlCZ3a__scroll-anchor",
  "section": "section-module-scss-module__PlCZ3a__section",
});
